export default __webpack_public_path__ + "static/media/Frame592.fdf0dcee.svg";